export const styles = () => ({
  container: {
    borderBottom: '1px solid var(--color-issabeline-grey)',
    paddingBottom: 32,
    marginBottom: 32,
  },
})
